<template>
  <div class="canvas-invoice">
    <div ref="imgRef" class="img-wrapper"></div>
  </div>
</template>

<script>
import InvoiceSample from 'invoice-sample'
export default {
  props: {
    invoiceData: {
      default: () => {},
      type: Object
    },
    showSample: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {
    this.draw(this.invoiceData)
  },
  methods: {
    draw (data) {
      let arr = data.drewDate ? data.drewDate.split(' ') : []
      data.drewDate = arr[0] || null
      data.specificElementVO = data.specificElements || []
      let invoiceSample = new InvoiceSample({ data })
      var image = new Image()
      let src = invoiceSample.getInvoiceSample({ showSample: this.showSample, samplePosition: 'top' })
      if (Number(data.invoiceType) === 7 || Number(data.invoiceType) === 8) {
        src = invoiceSample.getFullElectricity({ showSample: this.showSample })
      }
      image.src = src
      image.style.width = '100%'
      this.$refs.imgRef.appendChild(image)
    }
  },
  beforeDestroy () {
    this.$store.commit('invoice/initApplyData')
    this.$store.commit('invoice/changeGoodsList', [])
  }
}
</script>

<style lang="less" scoped src="./style.less"/>
